// extracted by extract-css-chunks-webpack-plugin
module.exports = {"message":"gift-message-card__message__13AHh"};